import React from "react";
import {useTranslation} from "react-i18next";
import {WallDeduction} from "../../../models/editor";
import {formatArea} from "../../../../../../../utils/TextUtils";
import {useUserSettingsDataContext} from "../../../../../../../providers/UserSettingsProvider";
import IconCut from "../../../icons/IconCut";
import "../../../components/groupItemPresenter.scss";

type WallDeductionItemProps = {
	deduction: WallDeduction;
	onEdit: () => void;
	onDelete: () => void;
	disabled?: boolean;
}

export function WallDeductionItem({deduction, onEdit, onDelete, disabled}: WallDeductionItemProps) {
	const {t} = useTranslation();
	const {settings} = useUserSettingsDataContext();
	const formattedArea = formatArea(deduction.area, settings?.measurementSystem);

	const handleEdit = () => !disabled && onEdit();
	const handleDelete = () => !disabled && onDelete();

	const handleKeyDown = (handler: () => void) => (e: React.KeyboardEvent) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			handler();
		}
	};

	const labelCls = [
		"group-item-presenter_label",
		!disabled && "is-clickable",
		disabled && "disabled",
	].filter(Boolean).join(" ");

	const actionsButtonCls = [
		"group-item-presenter_actions_button",
		disabled && "disabled",
	].filter(Boolean).join(" ");

	return (
		<div className="group-item-presenter">
			<div
				className={labelCls}
				onClick={handleEdit}
				onKeyDown={handleKeyDown(handleEdit)}
				role="button"
				tabIndex={disabled ? -1 : 0}
			>
				<div className="group-item-presenter_label_icon">
					<IconCut/>
				</div>
				{`${t("editor.topViewWallArea.deductionItemName")} (${formattedArea})`}
			</div>
			<div className="group-item-presenter_actions">
				<div
					className={actionsButtonCls}
					onClick={handleDelete}
					onKeyDown={handleKeyDown(handleDelete)}
					role="button"
					tabIndex={disabled ? -1 : 0}
					aria-label={t("editor.topViewWallArea.deleteDeduction")}
				>
					&times;
				</div>
			</div>
		</div>
	);
}
